import { emptyGisCoordinateResponse, GisCoordinateResponse } from "../GisCoordinateResponse";
import { NameEntityResponse } from "../NameEntityResponse";
import { ProjectFormatResponse } from "../ProjectFormatResponse";
import { ProjectCodeSystemResponse } from "../ProjectCodeSystemResponse";
import { CustomProjectPropertyValueResponse } from "../CustomProjectPropertyValueResponse";

export interface ProjectResponse {
  id: number;
  name: string;
  status: number;
  lead: NameEntityResponse;
  availableFrom: Date;
  deadline: Date;
  description: string;
  sewerObjectsCount: number;
  jobsCount: number;
  membersCount: number;
  created: Date;
  createdBy: NameEntityResponse;
  modified: Date;
  gisCoordinates: GisCoordinateResponse;
  format: ProjectFormatResponse | null;
  codeSystem: ProjectCodeSystemResponse | null;
  reportTemplate: NameEntityResponse;
  customProjectPropertyValues: CustomProjectPropertyValueResponse[];
  lastCompared: string;
  comparisonInProgress: boolean;
}

export const emptyProject: ProjectResponse = {
  id: 0,
  name: "",
  status: 0,
  lead: { id: 0, name: "", isDeleted: false },
  availableFrom: new Date(),
  deadline: new Date(),
  description: "",
  created: new Date(),
  createdBy: { id: 0, name: "", isDeleted: false },
  sewerObjectsCount: 0,
  jobsCount: 0,
  membersCount: 0,
  modified: new Date(),
  gisCoordinates: emptyGisCoordinateResponse,
  format: { id: "", name: "", language: "", readonly: false },
  codeSystem: { id: "", name: "", language: "", readonly: false },
  reportTemplate: { id: 0, name: "", isDeleted: false },
  customProjectPropertyValues: [],
  lastCompared: "",
  comparisonInProgress: false,
};
